import { Accordion } from '@mc/design-system'

const FaqSection = ({
  title,
  children,
}: {
  title: string
  children: React.ReactNode
}) => (
  <Accordion.Section className='mc-mt-9' label={title}>
    {children}
  </Accordion.Section>
)

export default FaqSection
